const ROUTE_MAP = "map";
const ROUTE_TABLE = "table";
const ROUTE_TABLESUM = "tablesum";
const ROUTE_STATS = "stats";
const ROUTE_HOME = "home";
const ROUTE_LOGIN = "login";
const ROUTE_DATABASE = "database";
const ROUTE_EVENTLOG = "eventlog";
const ROUTE_SEALNUMS = "sealnums";
const ROUTE_WORKSHIFT = "workshift";
const ROUTE_PROCESSED_QUALITIES = "processedqualities";
const ROUTE_QUALITIES_DETAILS = "qualitiesdetails";
const ROUTE_RAW_QUALITIES = "rawqualities";
const ROUTE_WEIGHBILL = "weighbill";
const ROUTE_MIXES = "mixes";
const ROUTE_MIX = "mix";
const ROUTE_STAT_ACTIVITY = "statactivity";
const ROUTE_PALLET_CHECK = "palletcheck";
const ROUTE_PALLET_CHECK_DETAILS = "palletcheckdetails";
const ROUTE_TRANSPORTER_MOVE = "transportermove";
const ROUTE_TRANSPORTER_CHECK = "transportercheck";
const ROUTE_TRANSPORTER_CHECK_DETAILS = "transportercheckdetails";

function createRoutes() {
  return [
    {
      name: ROUTE_HOME,
      path: "/",
      forwardTo: ROUTE_TABLE,
    },
    {
      name: ROUTE_MAP,
      path: "/map",
      onActivate: (params) => {},
    },
    {
      name: ROUTE_TABLE,
      path: "/table",
      onActivate: (params) => {},
    },
    {
      name: ROUTE_TABLESUM,
      path: "/tablesum",
      onActivate: (params) => {},
    },
    {
      name: ROUTE_STATS,
      path: "/stats",
    },
    {
      name: ROUTE_DATABASE,
      path: "/database",
    },
    {
      name: ROUTE_EVENTLOG,
      path: "/eventlog",
    },
    {
      name: ROUTE_SEALNUMS,
      path: "/sealnums",
    },
    {
      name: ROUTE_WORKSHIFT,
      path: "/workshift",
    },
    {
      name: ROUTE_PROCESSED_QUALITIES,
      path: "/processedqualities",
    },
    {
      name: ROUTE_QUALITIES_DETAILS,
      path: "/qualitiesdetails",
    },
    {
      name: ROUTE_WEIGHBILL,
      path: "/weighbill",
    },
    {
      name: ROUTE_RAW_QUALITIES,
      path: "/rawqualities",
    },
    {
      name: ROUTE_MIXES,
      path: "/mixes",
    },
    {
      name: ROUTE_MIX,
      path: "/mix",
    },
    {
      name: ROUTE_LOGIN,
      path: "/login",
    },
    {
      name: ROUTE_STAT_ACTIVITY,
      path: "/activity",
    },
    {
      name: ROUTE_PALLET_CHECK,
      path: "/palletcheck",
    },
    {
      name: ROUTE_PALLET_CHECK_DETAILS,
      path: "/palletcheckdetails",
    },
    {
      name: ROUTE_TRANSPORTER_MOVE,
      path: "/transportermove",
    },
    {
      name: ROUTE_TRANSPORTER_CHECK,
      path: "/transportercheck",
    },
    {
      name: ROUTE_TRANSPORTER_CHECK_DETAILS,
      path: "/transportercheckdetails",
    },
  ];
}

export {
  createRoutes,
  ROUTE_MAP,
  ROUTE_STATS,
  ROUTE_TABLE,
  ROUTE_TABLESUM,
  ROUTE_DATABASE,
  ROUTE_EVENTLOG,
  ROUTE_SEALNUMS,
  ROUTE_WORKSHIFT,
  ROUTE_PROCESSED_QUALITIES,
  ROUTE_QUALITIES_DETAILS,
  ROUTE_RAW_QUALITIES,
  ROUTE_WEIGHBILL,
  ROUTE_MIXES,
  ROUTE_MIX,
  ROUTE_LOGIN,
  ROUTE_STAT_ACTIVITY,
  ROUTE_PALLET_CHECK,
  ROUTE_PALLET_CHECK_DETAILS,
  ROUTE_TRANSPORTER_MOVE,
  ROUTE_TRANSPORTER_CHECK,
  ROUTE_TRANSPORTER_CHECK_DETAILS,
};
